import { render } from "./bk-emailVerify.vue?vue&type=template&id=72d06f84&scoped=true"
import script from "./bk-emailVerify.vue?vue&type=script&lang=js"
export * from "./bk-emailVerify.vue?vue&type=script&lang=js"

import "./bk-emailVerify.vue?vue&type=style&index=0&id=72d06f84&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d06f84"]])

export default __exports__